/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset properties that can be used for sorting. Default value is 'serialNumber'.
 *
 */
export var AssetPropertiesForSorting;
(function (AssetPropertiesForSorting) {
    AssetPropertiesForSorting["SERIAL_NUMBER"] = "serialNumber";
    AssetPropertiesForSorting["MAKE"] = "make";
    AssetPropertiesForSorting["MODEL"] = "model";
    AssetPropertiesForSorting["PRODUCT_FAMILY"] = "productFamily";
    AssetPropertiesForSorting["SUBSCRIPTION_TYPE"] = "subscriptionType";
    AssetPropertiesForSorting["BATTERY_HEALTH"] = "batteryHealth";
    AssetPropertiesForSorting["ASSET_CHARGING_STATUS"] = "assetChargingStatus";
    AssetPropertiesForSorting["BATTERY_STATE_OF_CHARGE"] = "batteryStateOfCharge";
    AssetPropertiesForSorting["LAST_KNOWN_LOCATION"] = "lastKnownLocation";
    AssetPropertiesForSorting["REMAINING_USEFUL_LIFE"] = "remainingUsefulLife";
    AssetPropertiesForSorting["REPLACEMENT_DATE"] = "replacementDate";
})(AssetPropertiesForSorting || (AssetPropertiesForSorting = {}));
